import { render, staticRenderFns } from "./makeList.vue?vue&type=template&id=6a3f3b10"
import script from "./makeList.vue?vue&type=script&lang=js"
export * from "./makeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports